import { useAuthStore } from '../../store/authStore';

/** The last sign-in failure from the auth store, shown once per auth page. */
export default function AuthError() {
    const { error } = useAuthStore();
    if (!error) return null;

    return (
        <p className="text-status-danger text-body" role="alert">
            {error}
        </p>
    );
}
